export default __webpack_public_path__ + "static/media/oscar.6481d9bc.png";